import { Stack, Tooltip } from '@mantine/core';
import type { PolicyViolationOut } from '@repo/api-codegen';
import { Badge, Text } from '@repo/foundations';
import { useStyles } from './styles';

interface ConditionsNotMetProps {
	violations: PolicyViolationOut[];
}

export function ConditionsNotMet({ violations }: ConditionsNotMetProps) {
	const { classes } = useStyles();
	const failingViolations = violations.filter(
		(ruleViolation) => !ruleViolation.is_passing
	);

	if (failingViolations.length === 0) {
		return <Badge variant="success">Passing</Badge>;
	}

	if (failingViolations.length === 1) {
		const isPiiScan = failingViolations[0].policy_rule.type === 'PII_SCAN';
		const label = isPiiScan
			? 'PII classifier'
			: failingViolations[0].policy_rule.name || 'Unnamed Rule';
		return (
			<Tooltip
				label={
					<Badge variant="warning" size="sm" my="xs">
						{label}
					</Badge>
				}
				position="top"
			>
				<Badge variant="warning" className={classes.badge}>
					<Text
						size="xs"
						color="text/warning/default"
						sx={{ textTransform: 'none' }}
					>
						{label}
					</Text>
				</Badge>
			</Tooltip>
		);
	}

	return (
		<Tooltip
			label={
				<Stack spacing="xs" py="xs">
					{failingViolations.map((violation) => (
						<Badge key={violation.id} variant="warning" size="sm">
							{violation.policy_rule.name || 'Unnamed Rule'}
						</Badge>
					))}
				</Stack>
			}
			position="top"
		>
			<Badge variant="warning">{failingViolations.length} issues</Badge>
		</Tooltip>
	);
}
